export default __webpack_public_path__ + "static/media/folder.f12b0dbf.svg";